import React from "react";
import yup from "yup";
import styled from "styled-components";
import { Field } from "formik";
import { Formik } from "components/generic/form/formik";
import { withState } from "recompose";
import { ButtonRound } from "components/generic/kit";
import caretRight from "../../assets/caret-right.svg";
import File from "../File";

export default withState("isSigning", "setSigning", false)(
  ({
    isAuthenticated,
    error,
    signUpErrors,
    createBooking,
    isSigning,
    setSigning,
    onSignInSubmit,
    onSignUpSubmit
  }) =>
    isAuthenticated ? (
      <SubmitWrap next>
        <ButtonRound onClick={createBooking} next>
          <span>Next</span>
          <img
            className="dn-ns db flex-end"
            src={caretRight}
            alt="Choose a time"
          />
        </ButtonRound>
      </SubmitWrap>
    ) : !isSigning ? (
      <Formik
        key="1"
        onSubmit={onSignUpSubmit}
        errors={signUpErrors}
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          password: "",
          password_confirmation: ""
        }}
        validationSchema={yup.object().shape({
          first_name: yup.string().required("First name is required"),
          last_name: yup.string().required("Last name is required"),
          email: yup
            .string()
            .required("Email is required")
            .email("Is not valid email"),
          password: yup
            .string()
            .required("Password is required")
            .min(8, "Password should be at least 8 characters length"),
          password_confirmation: yup
            .string()
            .required("Password confirmation is required"),
          resume: yup.mixed().required("Resume is required")
        })}
      >
        {props => (
          <form onSubmit={props.handleSubmit}>
            <React.Fragment>
              <Wrap>
                <Card>
                  <Title margin>
                    Contact information{" "}
                    <div className="ml-auto-ns ml0 f5 silver">
                      <React.Fragment>
                        Already a member?{" "}
                        <Action onClick={() => setSigning(true)}>
                          Sign in
                        </Action>
                      </React.Fragment>
                    </div>
                  </Title>
                  <FormWrap>
                    <div className="flex-ns db">
                      <div className="w-50-ns w-100 pa2">
                        <Field
                          placeholder="First Name"
                          name="first_name"
                          component={Input}
                        />
                      </div>
                      <div className="w-50-ns w-100 pa2">
                        <Field
                          placeholder="Last Name"
                          name="last_name"
                          component={Input}
                        />
                      </div>
                    </div>
                    <div className="flex">
                      <div className="w-50-ns w-100 pa2">
                        <Field
                          placeholder="Email"
                          name="email"
                          component={Input}
                        />
                      </div>
                      <div className="w-50 pa2">
                        <Field
                          placeholder="Mobile Phone (optional)"
                          name="mobile"
                          component={Input}
                        />
                      </div>
                    </div>
                    <div className="flex-ns db">
                      <div className="w-50-ns w-100 pa2">
                        <Field
                          placeholder="Choose a Password (At least 6 characters)"
                          name="password"
                          type="password"
                          component={Input}
                        />
                      </div>
                      <div className="w-50-ns w-100 pa2">
                        <Field
                          placeholder="Confirm Password"
                          name="password_confirmation"
                          type="password"
                          component={Input}
                        />
                      </div>
                    </div>
                  </FormWrap>
                  {error && (
                    <div className="tc">
                      <Error>{error}</Error>
                    </div>
                  )}
                </Card>
                <div className="mt5">
                  <Card>
                    <div className="flex flex-row-ns flex-column items-center relative">
                      <div className="f2-ns f4 mb0-ns mb2">
                        Upload your resume (required)
                      </div>
                      <div className="ml-auto-ns tc">
                        <File name="resume" />
                      </div>
                    </div>
                  </Card>
                </div>
              </Wrap>
              <SubmitWrap>
                <Submit next />
              </SubmitWrap>
            </React.Fragment>
          </form>
        )}
      </Formik>
    ) : (
      <Formik
        key="2"
        onSubmit={onSignInSubmit}
        initialValues={{
          email: "",
          password: ""
        }}
        validationSchema={yup.object().shape({
          email: yup
            .string()
            .required("Email is required")
            .email("Is not valid email"),
          password: yup
            .string()
            .required("Password is required")
            .min(8, "Password should be at least 8 characters length")
        })}
      >
        {props => (
          <form onSubmit={props.handleSubmit}>
            <React.Fragment>
              <Wrap>
                <Card>
                  <Title margin>
                    Contact information{" "}
                    <div className="ml-auto-ns ml0 f5 silver">
                      <Action onClick={() => setSigning(false)}>
                        Back to Sign up
                      </Action>
                    </div>
                  </Title>
                  <FormWrap>
                    <div className="flex">
                      <div className="w-50 pa2">
                        <Field
                          placeholder="Enter your email"
                          name="email"
                          component={Input}
                        />
                      </div>
                      <div className="w-50 pa2">
                        <Field
                          placeholder="Enter password"
                          name="password"
                          type="password"
                          component={Input}
                        />
                      </div>
                    </div>
                  </FormWrap>
                  {error && (
                    <div className="tc">
                      <Error>{error}</Error>
                    </div>
                  )}
                </Card>
              </Wrap>
              <SubmitWrap>
                <Submit next />
              </SubmitWrap>
            </React.Fragment>
          </form>
        )}
      </Formik>
    )
);

const Input = props => {
  const error = props.form.errors[props.field.name];
  const touched = props.form.touched[props.field.name];

  return (
    <div>
      <InputWrap
        isError={!!(error && touched)}
        {...props.field}
        placeholder={props.placeholder}
        type={props.type || "text"}
      />
      {touched && error && <Error>{error}</Error>}
    </div>
  );
};

const Submit = () => (
  <ButtonSubmit>
    <ButtonRound next>
      <span>Next</span>
      <img className="dn-ns db flex-end" src={caretRight} alt="Choose a time" />
    </ButtonRound>
  </ButtonSubmit>
);

const ButtonSubmit = styled.button.attrs({
  type: "submit"
})`
  appearance: none;
  outline: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  @media (max-width: 680px) {
    width: 100%;
  }
`;

const Error = styled.div`
  margin-top: 5px;
  color: #f76367;
`;

const InputWrap = styled.input`
  outline: 0;
  padding: 1rem 1.25rem;
  border: 1px solid #e6e5e0;
  display: block;
  width: 100%;
  box-sizing: border-box;
  font-family: "CircularStd-Book", sans-serif;
  ${({ isError }) =>
    isError &&
    `
    border-color: #f76367;
  `};
`;

const FormWrap = styled.div`
  margin: -0.5rem;
`;

const Action = styled.span`
  cursor: pointer;
  font-family: "CircularStd-Bold", sans-serif;
`;

const Title = styled.div`
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  ${({ margin }) =>
    margin &&
    `
    margin-bottom: 2rem;
  `};
  @media (max-width: 680px) {
    display: block;
    font-size: 1.2rem;
  }
`;

const Wrap = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  max-width: 1140px;
  margin: 0 auto;
  padding: 4rem 0;
  @media (max-width: 680px) {
    padding: 1rem 0;
    padding: 1rem 0 5rem 0;
  }
`;

const Card = styled.div`
  background-color: #fff;
  padding: 3rem 4rem;
  @media (max-width: 680px) {
    padding: 2rem 1rem;
  }
`;

const SubmitWrap = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding-bottom: 4rem;
  @media (max-width: 680px) {
    display: flex;
    width: 100%;
    padding: 0;
    position: absolute;
    bottom: 0;
  }
  ${({ next }) =>
    next &&
    `
    padding: 2rem 0;
    @media (max-width: 680px) {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/components/Info/View.js